import { axios } from '../http-common';
import DB from '../util/DB';
import moment from 'moment';

class Member {
  async domain(forceRefresh = false) {
    const cacheKey = 'domain_info';

    if (!forceRefresh) {
      const data = await DB.get(cacheKey);
      if (data) {
        return { status: 200, data: { data } };
      }
    }

    const response = await axios.get("v1/member/profile/domain");
    if (response.status === 200) {
      await DB.save(cacheKey, response.data.data);
    }

    return response;
  }

  async kycStatus({forceRefresh = false, onUpdate = null } = {}) {
    const cacheKey = 'kyc_status';

    const cached = await DB.get(cacheKey);
    if (cached && !forceRefresh) {
      if (typeof onUpdate === 'function') {
        onUpdate(cached.data);
      }

      axios.get("v1/member/profile/kyc-status").then(async (response) => {
        if (response.status === 200) {
          const newData = response.data.data;

          if (JSON.stringify(newData) !== JSON.stringify(cached.data)) {
            await DB.save(cacheKey, { data: newData, cachedAt: Date.now() });

            if (typeof onUpdate === 'function') {
              onUpdate(newData);
            }
          }
        }
      });

      return { status: 200, data: { data: cached.data } };
    }

    // Tidak ada cache atau force refresh
    const response = await axios.get("v1/member/profile/kyc-status");
    if (response.status === 200) {
      await DB.save(cacheKey, { data: response.data.data, cachedAt: Date.now() });
    }

    return response;
  }


  isKycDataValid(data = []) {
    return data.every(item => {
      if (item.status_code === 1) return true;

      const expireAt = item.expire_at;
      const m = moment(expireAt, 'YYYY-MM-DD HH:mm:ss', true);

      return m.isValid() && m.isAfter(moment());
    });
  }
}

export default new Member();